import React from 'react'

function Contact(props) {
  return (
    <div id='di4' style={{backgroundColor:`${props.mode==='light'?'#000028':'white'}`}}>
       <div className="contact" style={{color:`${props.mode==='light'?'white':'#000028'}`}}>
        <div style={{backgroundColor:`${props.mode==='light'?'white':'white'}`}}>
           <a target="_blank" href="https://linkedin.com/in/mr-singh-861050230"><img src="https://www.freeiconspng.com/thumbs/linkedin-logo-png/webtreatsetc-blue-jelly-linkedin-logo-19.png" alt="" /></a>
            
        </div>

        
        <div style={{backgroundColor:`${props.mode==='light'?'white':'white'}`}}>
        <a target="_blank" href="https://digvijaysinghpikku@gmail.com">
         <img src="https://cdn-icons-png.flaticon.com/512/5968/5968534.png" alt="" /> </a> 
        </div>
      


        <div style={{backgroundColor:`${props.mode==='light'?'white':'white'}`}}>
        <a target="_blank" href="https://github.com/Mr-Singhh"><img src="https://www.freeiconspng.com/uploads/github-mascot-logo-icon-13.png" alt="" /></a> 
      
        </div>
       </div>
    </div>
  )
}

export default Contact